module.exports = __webpack_public_path__ + "static/media/pay-gcash.52483d88.png";